// removed by extract-text-webpack-plugin
module.exports = {"buttonContainer":"ButtonsTemplate__buttonContainer___4yzKf"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/ButtonsTemplate.less
 ** module id = 755
 ** module chunks = 0
 **/